import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import "../assets/styles/PortalButton.css";

const WhyCampusPulse = () => {
  const navigate = useNavigate();

  return (
    <section className="portal-section-wrapper">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={9}>
            
            {/* The Premium Card */}
            <div className="portal-card" onClick={() => navigate('/about')}>
              
              {/* Decorative Background Elements */}
              <div className="card-decoration-grid"></div>
              <div className="card-decoration-circle"></div>

              <div className="portal-content">
                
                {/* Text Side */}
                <div className="portal-text w-100">
                  <div className="d-flex align-items-center gap-2 mb-3 justify-content-center justify-content-lg-start">
                     <Sparkles size={18} className="text-info" />
                     <span className="text-info small fw-bold text-uppercase tracking-wider">
                       اكتشف المزيد | Discover More
                     </span>
                  </div>
                  
                  {/* Title Block - ثنائي اللغة */}
                  <div className="mb-3 d-flex flex-column gap-1">
                    <h2 
                      dir="rtl" 
                      className="m-0 text-center text-lg-end" 
                      style={{ color: "#fff" }}
                    >
                      ليه تختار CampusPulse؟
                    </h2>
                    <h3 
                      dir="ltr" 
                      className="m-0 text-center text-lg-start" 
                      style={{ fontSize: "1.4rem", opacity: 0.6, fontWeight: "600", color: "#fff" }}
                    >
                      Why CampusPulse?
                    </h3>
                  </div>

                  {/* Description Block - ثنائي اللغة */}
                  <div className="d-flex flex-column gap-3 mb-4 mb-lg-0">
                    <p 
                      dir="rtl" 
                      className="m-0 text-center text-lg-end" 
                      style={{ color: "#f8fafc", fontSize: "1.15rem", fontWeight: "500", maxWidth: "100%" }}
                    >
                      بيئة متكاملة لحياتك الجامعية. الفعاليات، الحجوزات، والمجتمع — كلها في منصة واحدة متقدمة.
                    </p>
                    <p 
                      dir="ltr" 
                      className="m-0 text-center text-lg-start" 
                      style={{ opacity: 0.7, fontSize: "0.95rem", maxWidth: "100%" }}
                    >
                      A unified ecosystem for your university life. Events, booking, and community — all in one premium platform.
                    </p>
                  </div>
                </div>

                {/* Button Side */}
                <div className="flex-shrink-0 mt-4 mt-lg-0">
                  <button className="portal-btn d-flex flex-column align-items-center gap-1 px-4 py-3">
                    <span className="fw-bold" style={{ fontSize: "1.1rem" }}>استكشف المميزات</span>
                    <span className="d-flex align-items-center gap-2" style={{ fontSize: "0.85rem", opacity: 0.8 }}>
                      Explore Features <ArrowRight size={16} />
                    </span>
                  </button>
                </div>

              </div>
            </div>

          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhyCampusPulse;

// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import { ArrowRight, Sparkles } from "lucide-react";
// import "../assets/styles/PortalButton.css";

// const WhyCampusPulse = () => {
//   const navigate = useNavigate();

//   return (
//     <section className="portal-section-wrapper">
//       <Container>
//         <Row className="justify-content-center">
//           <Col xs={12} lg={10} xl={9}>
            
//             {/* The Premium Card */}
//             <div className="portal-card" onClick={() => navigate('/about')}>
              
//               {/* Decorative Background Elements (جوه الكارت بس) */}
//               <div className="card-decoration-grid"></div>
//               <div className="card-decoration-circle"></div>

//               <div className="portal-content">
                
//                 {/* Text Side */}
//                 <div className="portal-text">
//                   <div className="d-flex align-items-center gap-2 mb-2 justify-content-center justify-content-lg-start">
//                      <Sparkles size={18} className="text-info" />
//                      <span className="text-info small fw-bold text-uppercase tracking-wider">Discover More</span>
//                   </div>
//                   <h2>Why CampusPulse?</h2>
//                   <p>
//                     A unified ecosystem for your university life. 
//                     Events, booking, and community — all in one premium platform.
//                   </p>
//                 </div>

//                 {/* Button Side */}
//                 <div>
//                   <button className="portal-btn">
//                     Explore Features <ArrowRight size={20} />
//                   </button>
//                 </div>

//               </div>
//             </div>

//           </Col>
//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default WhyCampusPulse;